import React from "react"

import "./PersonalInfo.css"

const PersonalInfo = () => {

	let imagePath = "favicon.png";
	let userInfo = {
		name: "Boris Mitielte",
		emailEestec: "alsdnjkjadfs@eestec.ro",
		bday: "32.32.1977",
		memberTime: "Membru de ieri",
		city: "Galati",
		phone: "07777777",
		emailPersonal: "asdfads@gmail.com"
	}


	return (
		<div className="personalInfoContainer">
			<div className="profileImage">
				<img src={imagePath}></img>
				<div className="editIcon"><img src="icons/edit.svg"/></div>
			</div>
			<div className="profileText">
				<h2>{userInfo.name}</h2>
				<h3>{userInfo.emailEestec}</h3>
				<div><img src="icons/cake.svg"/><p>{userInfo.bday}</p></div>
				<div><img src="icons/clock.svg"/><p>{userInfo.memberTime}</p></div>
				<div><img src="icons/location.svg"/><p>{userInfo.city}</p></div>
				<div><img src="icons/phone.svg"/><p>{userInfo.phone}</p></div>
				<div><img src="icons/envelope.svg"/><p>{userInfo.emailPersonal}</p></div>
			</div>
		</div>
	);
}

export default PersonalInfo;